import React from "react";
import { LowerThird } from "./components/LowerThird";
import { FlatListItem } from "../../../components/partials/FlatList";
import { AnimatedFlatList } from "./components/AnimatedFlatList";
import { SquareList } from "./components/SquareList";

type CustomProps = {
  title: string;
  subtitle?: string;
};

const CustomSquare: React.FC<CustomProps> = ({ title, subtitle }) => {
  return (
    <SquareList style={{ gridArea: "listarea" }}>
      <header>
        <h1>{title}</h1>
      </header>
      {subtitle && (
        <main data-show="true">
          <div className="additional-info">{subtitle}</div>
        </main>
      )}
    </SquareList>
  );
};

const CustomListItem: React.FC<FlatListItem<CustomProps, null>> = ({
  item,
  onHidden,
  show,
}) => {
  return (
    <LowerThird
      header={<>{item.title}</>}
      onHidden={onHidden}
      show={show}
      className="flatlist-item"
    >
      <div>
        <span>{item.subtitle}</span>
      </div>
    </LowerThird>
  );
};

const CustomClassic: React.FC<CustomProps> = (props) => {
  return (
    <>
      <AnimatedFlatList
        items={[{ id: "custom", ...props }]}
        RenderComponent={CustomListItem}
        itemsPerPage={1}
        usePlaceholder={false}
      />
    </>
  );
};

export const Custom: React.FC<
  CustomProps & { variant: "classic" | "square" }
> = ({ variant, ...props }) => {
  if (variant === "square") {
    return <CustomSquare {...props} />;
  }
  return <CustomClassic {...props} />;
};
